import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgMarkerIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M32 1C20.694 1 9 9.639 9 24.095 9 39.24 30.383 60.797 31.293 61.707a.997.997 0 0 0 1.414 0C33.617 60.797 55 39.24 55 24.095 55 9.639 43.306 1 32 1zm0 31a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
      className="marker_svg__nc-icon-wrapper"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgMarkerStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgMarkerIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const MarkerIcon: any = SvgMarkerStyle;
export default MarkerIcon;
